import { BlogTitle } from "@/components/BlogTitle/BlogTitle.tsx";
import { Page } from "@/components/Page.tsx";
import "@/styles/Blog.scss";
import * as React from 'react';
export default {
  BlogTitle,
  Page,
  React
};